<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>My Credit Balance</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->
      <div class="container-filud">
      <div class=" margin_60_35">
        <div class="row">
          
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-10">
            <div class="isotope-wrapper">
              <table  class="table table-striped table-bordered table-sm" cellspacing="0" width="100%">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    
                    <th scope="col">Credit</th>
                    <th scope="col">Debit</th>
                    <th scope="col">Balance</th>
                    <th scope="col">Remark</th>
                    <th scope="col">Date/Time</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(service, index) in serviceBalance" :key="index">
                    <th scope="row">{{ index + 1 }}</th>
                  
                    <td>{{ service.credit }}</td>
                    <td>{{ service.debit }}</td>
                    <td>{{ service.balance }}</td>
                    <td>{{ service.remark }}</td>
                    <td>{{ service.timestamp }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>
    </div>
      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
import API from "@/services/index";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import jQuery from 'jquery';

export default {
  data() {
    return {
      token: "Bearer " + localStorage.getItem("token"),
      serviceBalance: [],
    dt: null,
    };
  },
  watch: {
    serviceBalance() {
      this.dt.destroy();

      this.$nextTick(() => {
        this.dt = jQuery(".table").DataTable();
      });
    },
  },
  beforeMount() {
    this.checkToken();
    this.getServiceBalanceReport();
  },

  methods: {
    checkToken() {
      const token = localStorage.getItem("token");
      // alert(token);
      if (token == null) {
        this.$router.push("/signin");
      }
    },
    getServiceBalanceReport() {
      const form = new FormData();
      const token = "Bearer " + localStorage.getItem("token");

      API.post("/profile/service_balance_report", form, {
        headers: { Authorization: token },
      }).then((res) => {
        if (res.data.status == 200) {
            this.dt=jQuery('.table').DataTable();
     setTimeout(() => (this.serviceBalance = res.data.data));
                 
        }
      });
    },
  },
  components: {
    Frontendlayout,
    Sidebar,
  },
};
</script>
<style  scoped>
</style>